var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotspot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 300 300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 57.172,
    x2: 226.33,
    y1: 242.83,
    y2: 73.669,
    gradientUnits: "userSpaceOnUse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#107eff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556ee6",
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m150 42c-59.551 0-108 48.449-108 108 0 2.211 1.791 4 4 4h16c2.209 0 4-1.789 4-4 0-22.705 9.093-43.302 23.782-58.435l8.079 8.619c1.51 1.613 4.043 1.695 5.652.184 11.664-10.93 26.623-17.328 42.486-18.25v8.085c-29.889 1.985-53.811 25.905-55.796 55.797h-12.203c-2.209 0-4 1.789-4 4 0 40.556 31.958 73.698 72 75.797v28.203c0 2.211 1.791 4 4 4 59.551 0 108-48.449 108-108s-48.449-108-108-108zm-48.967 49.871-5.414-5.774c14.669-12.503 33.641-20.097 54.381-20.097 46.318 0 84 37.684 84 84 0 44.617-35.686 81.801-80 83.906v-8.109c40.042-2.1 72-35.241 72-75.797 0-41.906-34.094-76-76-76-18.037 0-35.273 6.316-48.967 17.871zm48.967 6.129c28.674 0 52 23.328 52 52 0 27.322-21.194 49.742-48 51.797v-7.977c22.395-2.027 40-20.906 40-43.82 0-24.262-19.738-44-44-44-22.914 0-41.793 17.605-43.82 40h-8.027c2.048-26.812 24.521-48 51.847-48zm-51.797 56h11.797c2.209 0 4-1.789 4-4 0-19.852 16.15-36 36-36s36 16.148 36 36-16.15 36-36 36c-2.209 0-4 1.789-4 4v11.797c-25.481-1.953-45.844-22.318-47.797-47.797zm55.797 95.922v-8.008c48.711-2.113 88-42.918 88-91.914 0-50.73-41.271-92-92-92-24.17 0-46.178 9.386-62.614 24.684-.09.07-.2.096-.285.176-.076.072-.105.17-.175.246-16.887 15.931-27.777 38.158-28.84 62.894h-8.008c2.108-53.293 46.121-96 99.922-96 55.141 0 100 44.859 100 100 0 53.801-42.707 97.812-96 99.922zm-55.516-10.75-2.828 2.828 2.828 2.828c1.562 1.562 1.562 4.094 0 5.656-.781.781-1.805 1.172-2.828 1.172s-2.047-.391-2.828-1.172l-2.828-2.828-2.828 2.828c-.781.781-1.805 1.172-2.828 1.172s-2.047-.391-2.828-1.172c-1.562-1.562-1.562-4.094 0-5.656l2.828-2.828-2.828-2.828c-1.562-1.562-1.562-4.094 0-5.656s4.094-1.562 5.656 0l2.828 2.828 2.828-2.828c1.562-1.562 4.094-1.562 5.656 0s1.563 4.093 0 5.656zm-32.484-49.172c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4 4 1.791 4 4zm-12 40c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4 4 1.791 4 4z",
    fill: "url(#a)",
    style: {},
    "data-original": "url(#SVGID_1_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspot);
export default __webpack_public_path__ + "static/media/hotspot.564cc65a.svg";
export { ForwardRef as ReactComponent };